import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import { Redirect } from 'react-router-dom';

type Props = {
  msg?: string;
};
export default function NotFoundRedirect({
  msg,
}: Props): JSX.Element {
  const { showSnack } = useShowInfo();
  showSnack({
    message: msg || 'That product has been deleted already',
    alertType: 'error',
  });
  return <Redirect to={SharedRoutePath.HOME} />;
}
